export { ServiceSingle } from './ServiceSingle';
